import oeeReducer from "./reducers";

export default oeeReducer;